import $ from 'jquery'
/**
 * @module
 * @api
 */

import Button from './Button'

/**
 * UI tool class
 * @constructor
 */
export default function Ui() {
  this.elemets = {
    $navbarNorth: $('#navbarNorth'),
    $navbarSouth: $('#navbarSouth')
  }
}

/**
 * Add UI button
 * @param {string} position Where to render button. Supported positions are "top" and "bottom".
 * @param {string} label
 * @param {string} icon A Font Awsome CSS class name eg. "fa-arrows-alt".
 * @return {Button} button object
 * @memberof! module:api/Ui#
 * @api
 */
Ui.prototype.addButton = function(position, label, icon) {
  var button = new Button(position)

  button.text(label)
  button.icon(icon)

  this.addButtonToDOM(button.$element, position)

  return button
}

/**
 * Set a custom header title and/or subtitle.
 * If title or subtitle is set the default version number will be hidden.
 * If title and subtitle both are set to null the default version will be shown
 * @param {string} title Title to set. Can be set to null.
 * @param {string} subtitle Subtitle to set. Can be set to null.
 * @memberof! module:api/Ui#
 * @api
 */
Ui.prototype.setCustomHeader = function(title, subtitle) {
  if (!title && !subtitle) {
    $('#navbarNorth .customheader').addClass('hide')
    $('#navbarNorth .version').removeClass('hide')
    return
  }

  $('#navbarNorth .customheader .title').text(title)
  $('#navbarNorth .customheader .subtitle').text(subtitle)

  $('#navbarNorth .customheader').removeClass('hide')
  $('#navbarNorth .version').addClass('hide')

  if (title && subtitle) {
    $('#navbarNorth .customheader .title').removeClass('hide')
    $('#navbarNorth .customheader .subtitle').removeClass('hide')

    $('#navbarNorth .customheader').removeClass('onlytitle')
    $('#navbarNorth .customheader').removeClass('onlysubtitle')
  } else if (title && !subtitle) {
    $('#navbarNorth .customheader .title').removeClass('hide')
    $('#navbarNorth .customheader .subtitle').addClass('hide')

    $('#navbarNorth .customheader').removeClass('onlysubtitle')
    $('#navbarNorth .customheader').addClass('onlytitle')
  } else if (!title && subtitle) {
    $('#navbarNorth .customheader .title').addClass('hide')
    $('#navbarNorth .customheader .subtitle').removeClass('hide')

    $('#navbarNorth .customheader').addClass('onlysubtitle')
    $('#navbarNorth .customheader').removeClass('onlytitle')
  }
}

/**
 * Add button to the DOM
 * @param {element} button as jQuery element
 * @param {string} position
 */
Ui.prototype.addButtonToDOM = function(button, position) {
  switch (position) {
    case 'bottomRight':
      button.prependTo(
        this.elemets.$navbarSouth.find('.pull-right .ui-buttons')
      )
      break
    case 'bottomLeft':
      button.appendTo(this.elemets.$navbarSouth.find('.pull-left .btn-group'))
      break
    case 'topLeft':
      button.appendTo(
        this.elemets.$navbarNorth.find('.pull-left').find('.navbar-nav')
      )
      break
    case 'topRight':
      button.prependTo(
        this.elemets.$navbarNorth.find('.pull-right').find('.navbar-nav')
      )
      break
    default:
      window.console.warn(
        position +
          'is not a valid position. Valid positions are bottomRight, bottomLeft, topLeft and topRight.'
      )
  }
}

Ui.prototype.getNavbarsHeight = function() {
  return ({
    north: this.elemets.$navbarNorth.css("visibility") == "hidden" ? 0: this.elemets.$navbarNorth.outerHeight(),
    south: this.elemets.$navbarSouth.css("visibility") == "hidden" ? 0: this.elemets.$navbarSouth.outerHeight()
  })
}
